import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  skipProfileCheck?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, skipProfileCheck = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!skipProfileCheck && (!user.name || !user.bio || !user.imageUrl)) {
    return <Navigate to="/settings" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
